import React from 'react';
import Text from '@amzn/meridian/text';
import { ErrorRecord } from 'src/hooks/useForm';
import Row from '@amzn/meridian/row';
import Input from '@amzn/meridian/input';
import { Modification } from 'src/types/modification';

interface SiteFormFieldsProps {
  formData: Modification;
  errors: ErrorRecord<Modification>;
  handleChange: (key: keyof Modification, value: any) => void;
}
const JobModificationFormFields = ({ formData, errors, handleChange }: SiteFormFieldsProps) => {
  return (
    <div>
      <Row widths="fill" spacingInset={'400 none'}>
        <Text>Name</Text>
        <Input
          type="text"
          placeholder="Enter name..."
          aria-label="Name"
          value={formData.name}
          onChange={(label) => {
            handleChange('name', label);
          }}
          error={errors.name?.error}
          errorMessage={errors.name?.errorMessage}
        />
      </Row>
      <Row widths="fill" spacingInset={'400 none'}>
        <Text>Description</Text>
        <Input
          type="text"
          placeholder="Enter description..."
          aria-label="Description"
          value={formData.description}
          onChange={(description) => {
            handleChange('description', description);
          }}
          error={errors.description?.error}
          errorMessage={errors.description?.errorMessage}
        />
      </Row>
    </div>
  );
};

export default JobModificationFormFields;
